import angular from 'angular';

import accessRulesTabComponent from './tabs/accessRulesTabComponent.js';
import approversTabComponent from './tabs/approversTabComponent.js';

angular
	.module('sh.postEditor', [])
	.component('shAccessRulesTab', accessRulesTabComponent)
	.component('shApproversTab', approversTabComponent);
